module.exports = __webpack_public_path__ + "static/media/logo.93c33ff6.svg";